import { RouteType } from "types/RouteType";

/**
 * Vending Integration Route
 * Integration with Jason's automated vending machine database (Phase 5)
 *
 * KEY FEATURES:
 * - Track employee supply purchases from vending machines
 * - Automatic payroll deductions for exceeding free allocation
 * - Sync with vending machine database
 * - Usage reports by employee and plant
 */
export const vendingIntegrationRoute: RouteType = {
  name: "Vending Integration",
  path: "/payroll/admin/vending",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Vending Integration",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./VendingIntegration.Header"),
    },
    body: {
      component: () => import("./VendingIntegration.Body"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "VendingTransactionDialog",
      title: "Transaction Details",
      component: () => import("./VendingTransactionDialog"),
    },
    {
      name: "VendingDeductionDialog",
      title: "Process Deduction",
      component: () => import("./VendingDeductionDialog"),
    },
    {
      name: "VendingSyncConfigDialog",
      title: "Sync Configuration",
      component: () => import("./VendingSyncConfigDialog"),
    },
  ],
  group: "Payroll Admin",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async () => {
    return true;
  },
};

export default vendingIntegrationRoute;
